 <div class="eui-card-media__container">
    <ng-container *ngIf="imageClickUrl">
        <a routerLink="{{imageClickUrl}}" class="eui-card-media__container-content">
            <ng-content *ngTemplateOutlet="mediacontent"></ng-content>
        </a>
    </ng-container>
    <ng-container *ngIf="imageClickUrlExternal">
        <a href="{{imageClickUrlExternal}}" target="_blank" class="eui-card-media__container-content">
            <ng-content *ngTemplateOutlet="mediacontent"></ng-content>
        </a>
    </ng-container>
    <ng-container *ngIf="!imageClickUrl && !imageClickUrlExternal">
        <ng-content *ngTemplateOutlet="mediacontent"></ng-content>
    </ng-container>
</div>
<ng-template #mediacontent>
    <img mat-card-image [src]="imageUrl" alt="{{!imageLegend? imageDescription: '' }}">
    <div *ngIf="imageLegend" class="eui-card-media__legend">{{ imageLegend }}</div>
</ng-template>
